<template>
  <div class="di-carousel-container position-relative" v-if="itemActive !== null" @mouseover="showArrows = true" @mouseleave="hideArrowsAnimation">
    <div class="di-carousel-item">
      <img :src="itemActive" alt="" v-if="isItemActiveImage">
      <video v-if="isItemActiveVideo" controls>
        <source :src="itemActive" type='video/webm; codecs="vp8, vorbis"' />
        <source :src="itemActive" type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"' />
        Video tag not supported. Download the video <a :href="itemActive">here</a>.
      </video>
    </div>
    <div class="arrow-container arrow-left-container" @click.prevent.stop="moveSlider('left')" v-if="showArrows && hasMultipleItems">
      <Arrow class="arrow left-arrow"></Arrow>
    </div>
    <div class="arrow-container arrow-right-container" @click.prevent.stop="moveSlider('right')" v-if="showArrows && hasMultipleItems">
      <Arrow class="arrow right-arrow"></Arrow>
    </div>
  </div>
</template>

<script>
import Helper from '@/helpers/Helper'
import Arrow from '@/assets/img/arrow-small.svg'
import { gsap } from 'gsap'

export default {
  name: 'DICarousel',
  props: ['items'],
  components: {
    Arrow
  },
  data () {
    return {
      activePos: 0,
      itemActive: null,
      showArrows: false
    }
  },
  computed: {
    isItemActiveImage () {
      return Helper.isURLImage(this.itemActive)
    },
    isItemActiveVideo () {
      return Helper.isURLVideo(this.itemActive)
    },
    hasMultipleItems () {
      return this.items.length > 1
    }
  },
  methods: {
    moveSlider (arrow) {
      if (arrow === 'left') {
        this.moveSliderLeft()
      } else {
        this.moveSliderRight()
      }
    },
    moveSliderLeft () {
      this.activePos--
      if (this.activePos < 0) {
        this.activePos = (this.items.length - 1)
      }
      this.selectActiveItem()
    },
    moveSliderRight () {
      this.activePos++
      if (this.activePos === this.items.length) {
        this.activePos = 0
      }
      this.selectActiveItem()
    },
    selectActiveItem () {
      this.itemActive = this.items[this.activePos]
    },
    showArrowsAnimation () {
      this.$nextTick(() => {
        const tl = gsap.timeline()

        tl.from('.arrow-container', {
          duration: 0.5,
          width: '0',
          ease: 'power2.out'
        })
        tl.from('.arrow', {
          duration: 0.5,
          opacity: 0,
          ease: 'power2.out'
        }, '>')
      })
    },
    hideArrowsAnimation () {
      this.$nextTick(() => {
        const tl = gsap.timeline({
          onComplete: () => {
            this.showArrows = false
          }
        })

        tl.to('.arrow', {
          duration: 0.5,
          opacity: 0,
          ease: 'power2.out'
        })
        tl.to('.arrow-container', {
          duration: 0.5,
          width: '0',
          ease: 'power2.out'
        }, '>')
      })
    }
  },
  mounted () {
    this.selectActiveItem()
    if (window.innerWidth <= 768) {
      this.showArrows = true
    }
  },
  watch: {
    showArrows: {
      handler () {
        if (window.innerWidth > 768) {
          if (this.showArrows && this.hasMultipleItems) {
            this.showArrowsAnimation()
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .di-carousel-container {
    width: 100%;
    position: relative;
    .di-carousel-item {
      width: 100%;
      height: 500px;
      img {
        width: 100%;
        @supports (object-fit: cover) {
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
      }
      video {
        width: 100%;
        @supports (object-fit: cover) {
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
      }
    }
    .arrow-container {
      position: relative;
      position: absolute;
      top: 0;
      height: 100%;
      width: var(--main-space);
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 10;
      cursor: pointer;
      &.arrow-left-container {
        left: 0;
      }
      &.arrow-right-container {
        right: 0;
      }

      .arrow {
        position: absolute;
        bottom: 16px;
        left: 50%;
        transform: translateX(-50%);
        width: 16px;
        &.left-arrow {
          transform: translateX(-50%) rotate(180deg);
        }
      }
    }

  }
  @include media-breakpoint-down(sm) {
    .di-carousel-container {
      .di-carousel-item {
        height: 300px;
      }
    }
    .arrow-container {
      width: 40px !important;
    }
  }
</style>
